/**
 * Kaching Bundles – Custom Style Fixes (v3)
 *
 * Layout per bundle card (horizontal/grid mode):
 *   1. Title          — e.g. "4 Magnets"
 *   2. Full Price     — e.g. "$19.95 AUD"  (primary price row)
 *   3. Per Magnet     — e.g. "$4.99 per magnet"  12px · #4E4E4E
 *   4. Save $Value    — red pill · pinned to bottom of card
 *
 * Also: MOST POPULAR badge rendered on the 12 Magnets card (CkSQ).
 */

(function () {
    /* ─────────────────────────────────────────
       EMBEDDED CSS
    ───────────────────────────────────────── */
    const css = `

    /* ══════════════════════════════════════
       CARD LAYOUT — flex column so "Save"
       can be pushed to the very bottom
    ══════════════════════════════════════ */

    /* The bar wrapper becomes a flex column that fills full card height */
    .kaching-bundles__bars--horizontal .kaching-bundles__bar-wrapper {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: flex-start !important;
      padding: 40px 7px 12px !important; /* top room for badge */
      height: 100% !important;
      box-sizing: border-box !important;
    }

    /* bar-main: flex column, content starts at TOP (no space-between stretching) */
    .kaching-bundles__bars--horizontal .kaching-bundles__bar-main {
      flex: 1 !important;
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      justify-content: flex-start !important;
      gap: 0 !important;
      width: 100% !important;
      text-align: center !important;
    }

    /* bar-content: auto height — do NOT stretch to fill (prevents gaps) */
    .kaching-bundles__bars--horizontal .kaching-bundles__bar-content {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      width: 100% !important;
      flex: 0 0 auto !important;
    }

    .kaching-bundles__bars--horizontal .kaching-bundles__bar-content-left {
      display: flex !important;
      flex-direction: column !important;
      align-items: center !important;
      width: 100% !important;
    }

    /* ══════════════════════════════════════
       ORDER CONTROL
       1) title (bar-first-line)
       2) full price (bar-pricing)
       3) per magnet (kb-per-magnet)  ← injected
       4) save pill (bar-second-line) ← pushed bottom
    ══════════════════════════════════════ */

    .kaching-bundles__bars--horizontal .kaching-bundles__bar-first-line {
      order: 1;
      margin-bottom: 4px !important;
    }

    .kaching-bundles__bars--horizontal .kaching-bundles__bar-pricing {
      order: 2;
      align-items: center !important;
    }

    /* Our injected "per magnet" label */
    .kaching-bundles__bars--horizontal .kb-per-magnet {
      order: 3;
      font-size: 12px !important;
      color: #4E4E4E !important;
      margin-top: 2px !important;
      margin-bottom: 4px !important;
      text-align: center !important;
    }

    /* Save pill — styled; actual DOM position handled by JS */
    .kaching-bundles__bars--horizontal .kaching-bundles__bar-second-line {
      margin-top: auto !important; /* This pushes the pill to the bottom */
      padding-top: 15px !important; /* Adds a little breathing room above the pill */
      justify-content: center !important;
      width: 100% !important;
      display: flex !important; /* Ensure it behaves as a flex item */
    }

    /* ══════════════════════════════════════
       MOBILE — 2-column (2 × 3) grid
       Overrides kaching's default 3-col
    ══════════════════════════════════════ */
    @media (max-width: 749px) {
      .kaching-bundles__bars--horizontal.kaching-bundles__bars {
        grid-template-columns: repeat(2, 1fr) !important;
      }
    }

    /* ══════════════════════════════════════
       PRICING ROWS
    ══════════════════════════════════════ */

    /* Hide the per-item row — we display it ourselves as kb-per-magnet */
    .kaching-bundles__bars--horizontal .kaching-bundles__bar-pricing-row--main {
      display: none !important;
    }

    /* Show the TOTAL price row as the big headline price */
    .kaching-bundles__bars--horizontal .kaching-bundles__bar-pricing-row--secondary {
      display: flex !important;
    }

    /* Hide the strikethrough compare-at price */
    .kaching-bundles__bar-full-price {
      display: none !important;
    }

    /* Hide kaching's built-in unit-label inside the price  */
    .kaching-bundles__bar-price__unit-label {
      display: none !important;
    }

    /* ══════════════════════════════════════
       PRICE TEXT SIZING
    ══════════════════════════════════════ */

    .kaching-bundles__bars--horizontal .kaching-bundles__bar-price {
      font-size: var(--bar-title-font-size, 20px) !important;
      font-weight: 500 !important;
      color: var(--bar-price-color, #000) !important;
    }

    /* ══════════════════════════════════════
       CURRENCY CODE — inline, same size
    ══════════════════════════════════════ */

    .kb-currency-code {
      font-size: inherit !important;
      font-weight: inherit !important;
      color: inherit !important;
      vertical-align: baseline !important;
      letter-spacing: inherit !important;
      margin-left: 2px !important;
    }

    /* ══════════════════════════════════════
       SAVE PILL — red / orange style
    ══════════════════════════════════════ */

    .kaching-bundles__bar-subtitle {
      display: inline-block !important;
      background-color: rgba(200, 82, 42, 0.12) !important;
      color: rgb(200, 82, 42) !important;
      border-radius: 20px !important;
      padding: 3px 10px !important;
      font-size: 13px !important;
      font-weight: 500 !important;
    }

    /* ══════════════════════════════════════
       TITLE NUMBER / LABEL
    ══════════════════════════════════════ */

    .kb-title-number {
      font-size: 1.4em;
      font-weight: 700;
      line-height: 1;
    }
    .kb-title-label {
      font-size: 1em;
      font-weight: 500;
    }

    /* ══════════════════════════════════════
       MOST POPULAR BADGE
       Centered at top of card, pill style,
       red background — only for 12 Magnets
    ══════════════════════════════════════ */

    /* Allow overflow so the badge peeks above the card border */
    .kaching-bundles__bars--horizontal,
    .kaching-bundles__bar,
    .kaching-bundles__bar-container,
    .kaching-bundles__bar-wrapper,
    .kaching-bundles__bar-main,
    .kaching-bundles__bar-content,
    .kaching-bundles__bar-content-left {
      overflow: visible !important;
    }

    .kaching-bundles__bar {
      position: relative !important;
    }

    /* Our custom badge element (injected) */
    .kb-most-popular-badge {
      position: absolute !important;
      top: -13px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      z-index: 99 !important;
      background-color: #C8522A !important;
      color: #ffffff !important;
      font-size: 10px !important;
      font-weight: 700 !important;
      padding: 4px 14px !important;
      border-radius: 12px !important;
      white-space: nowrap !important;
      text-transform: uppercase !important;
      letter-spacing: 0.05em !important;
      pointer-events: none !important;
    }

    /* Also support kaching's native badge element (in case it renders one) */
    .kaching-bundles__bar-most-popular {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      position: absolute !important;
      top: -13px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      z-index: 99 !important;
      white-space: nowrap !important;
    }

    .kaching-bundles__bar-most-popular__content {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      background-color: #C8522A !important;
      color: #ffffff !important;
      font-size: 10px !important;
      font-weight: 700 !important;
      padding: 4px 14px !important;
      border-radius: 12px !important;
      white-space: nowrap !important;
      text-transform: uppercase !important;
      letter-spacing: 0.05em !important;
    }

    /* Remove kaching's decorative triangles on the native badge */
    .kaching-bundles__bar-most-popular__content::before,
    .kaching-bundles__bar-most-popular__content::after {
      display: none !important;
    }

    /* Nudge the card main content down slightly to make room for badge */
    .kaching-bundles__bar-container:has(.kb-most-popular-badge) .kaching-bundles__bar-wrapper,
    .kaching-bundles__bar-container:has(.kaching-bundles__bar-most-popular) .kaching-bundles__bar-wrapper {
      padding-top: 44px !important;
    }
  `;

    const styleTag = document.createElement('style');
    styleTag.id = 'kb-fixes-v3';
    styleTag.textContent = css;
    document.head.appendChild(styleTag);

    /* ─────────────────────────────────────────
       HELPER — currency code
    ───────────────────────────────────────── */
    function getCurrencyCode() {
        try {
            const cfg = document.getElementById('kaching-bundles-config');
            if (cfg) {
                const data = JSON.parse(cfg.textContent);
                return data.marketCurrencyCode || 'AUD';
            }
        } catch (_) { }
        return 'AUD';
    }
    const CURRENCY = getCurrencyCode();

    /* ─────────────────────────────────────────
       HELPER — get per-item unit price from
       the secondary pricing row
    ───────────────────────────────────────── */
    function getPerMagnetPrice(barEl) {
        // The secondary row contains the per-item price
        const secondaryRow = barEl.querySelector('.kaching-bundles__bar-pricing-row--secondary .kaching-bundles__bar-price');
        if (!secondaryRow) return null;

        // Collect text content (ignore currency code span)
        let price = '';
        secondaryRow.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                price += node.textContent.trim();
            }
        });
        if (!price) {
            // fallback: full text minus the currency span
            price = secondaryRow.textContent.replace(CURRENCY, '').trim();
        }
        return price;
    }

    /* ─────────────────────────────────────────
       DOM PATCHER
    ───────────────────────────────────────── */
    function patchBars() {
        const block = document.querySelector('.kaching-bundles__block');
        if (!block) return;

        /* ── Title: big number ── */
        block.querySelectorAll('.kaching-bundles__bar-title').forEach(el => {
            if (el.dataset.kbPatched) return;
            el.dataset.kbPatched = '1';

            const raw = el.textContent.trim();
            const match = raw.match(/^(\d+)\s+(.+)$/);
            if (match) {
                el.innerHTML =
                    `<span class="kb-title-number">${match[1]}</span> ` +
                    `<span class="kb-title-label">${match[2]}</span>`;
            }
        });

        /* ── Round "Save $X" — strip decimals ── */
        block.querySelectorAll('.kaching-bundles__bar-subtitle').forEach(el => {
            if (el.dataset.kbRounded) return;
            el.dataset.kbRounded = '1';

            el.textContent = el.textContent.replace(
                /\$([0-9,]+)(\.\d+)?/g,
                (_, whole) => `$${whole}`
            );

            const subtitleObserver = new MutationObserver(() => {
                el.textContent = el.textContent.replace(
                    /\$([0-9,]+)(\.\d+)?/g,
                    (_, whole) => `$${whole}`
                );
            });
            subtitleObserver.observe(el, { childList: true, characterData: true, subtree: true });
        });

        /* ── Currency code inline — on the SECONDARY row (total price shown big) ── */
        block.querySelectorAll('.kaching-bundles__bar-pricing-row--secondary .kaching-bundles__bar-price').forEach(el => {
            if (el.dataset.kbCurrency) return;
            el.dataset.kbCurrency = '1';

            const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
            let textNode = walker.nextNode();
            while (textNode) {
                if (!textNode.textContent.includes(CURRENCY) &&
                    textNode.textContent.trim().length > 0) {
                    const tag = document.createElement('span');
                    tag.className = 'kb-currency-code';
                    tag.textContent = ' ' + CURRENCY;
                    textNode.parentNode.insertBefore(tag, textNode.nextSibling);
                    break;
                }
                textNode = walker.nextNode();
            }
        });

        /* ── Inject "per magnet" label + move Save pill to bottom ── */
        block.querySelectorAll('.kaching-bundles__bar').forEach(barEl => {
            const barMain = barEl.querySelector('.kaching-bundles__bar-main');
            const pricing = barEl.querySelector('.kaching-bundles__bar-pricing');
            if (!barMain || !pricing) return;

            // ── Per-magnet label (position 3) ──
            // Read from the --main row which holds the per-item price (e.g. $100.00)
            if (!barEl.querySelector('.kb-per-magnet')) {
                const mainPrice = barEl.querySelector('.kaching-bundles__bar-pricing-row--main .kaching-bundles__bar-price');
                if (mainPrice) {
                    // Extract raw dollar text from text nodes only (skip currency span)
                    let priceText = '';
                    mainPrice.childNodes.forEach(node => {
                        if (node.nodeType === Node.TEXT_NODE) {
                            const t = node.textContent.trim();
                            if (t) priceText = t;
                        }
                    });
                    if (!priceText) {
                        priceText = mainPrice.textContent.replace(CURRENCY, '').replace('AUD', '').trim();
                    }
                    // Keep decimals — do NOT strip .00

                    const label = document.createElement('div');
                    label.className = 'kb-per-magnet';
                    label.textContent = `${priceText} per magnet`;
                    // Insert right after the pricing block
                    pricing.after(label);
                }
            }

            // ── Move Save pill (bar-second-line) to very bottom of bar-main ──
            // It starts inside bar-content-left (above pricing), we move it after
            // kb-per-magnet so it becomes the last child of bar-main.
            const savePill = barEl.querySelector('.kaching-bundles__bar-second-line');
            if (savePill && savePill.parentElement !== barMain) {
                // Only move if it has content (subtitle exists)
                barMain.appendChild(savePill);
            }
        });

        /* ── MOST POPULAR badge — only on 12 Magnets (id="CkSQ") ── */
        block.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id="CkSQ"]').forEach(barEl => {
            if (barEl.querySelector('.kb-most-popular-badge')) return; // already injected

            const container = barEl.querySelector('.kaching-bundles__bar-container');
            if (!container) return;

            // Check if kaching already rendered its native badge — if so, restyle it
            const nativeBadge = barEl.querySelector('.kaching-bundles__bar-most-popular');
            if (nativeBadge) {
                // Already there — CSS handles it
                return;
            }

            // Inject our own badge
            const badge = document.createElement('div');
            badge.className = 'kb-most-popular-badge';
            badge.textContent = 'MOST POPULAR';
            container.appendChild(badge);
        });

        /* ── Remove MOST POPULAR badge from all other bars ── */
        block.querySelectorAll('.kaching-bundles__bar:not([data-deal-bar-id="CkSQ"]) .kb-most-popular-badge').forEach(el => {
            el.remove();
        });
    }

    /* ─────────────────────────────────────────
       FALLBACK SWAP
       Static pack-card grid is always rendered
       server-side as a safe fallback.
       When Kaching actually renders bundle
       content, we hide the static grid and
       reveal the Kaching container instead.
    ───────────────────────────────────────── */
    function toggleFallback() {
        const kachingBundle = document.querySelector('[data-cyp-kaching-bundle]');
        if (!kachingBundle) return; // no app block in this section — static grid stays

        // Kaching renders a .kaching-bundles__block with bar children inside the bundle container
        const kachingBlock = kachingBundle.querySelector('.kaching-bundles__block, .kaching-bundles__bars');
        const hasContent   = kachingBlock && kachingBlock.children.length > 0;

        const staticGrid = document.querySelector('[data-cyp-static-grid]');

        if (hasContent) {
            // Kaching has rendered — show it, hide the static fallback
            kachingBundle.style.display = '';
            if (staticGrid) staticGrid.style.display = 'none';
        } else {
            // Kaching is empty — show static fallback
            if (staticGrid) staticGrid.style.display = '';
            kachingBundle.style.display = 'none';
        }
    }

    /* ─────────────────────────────────────────
       OBSERVER
    ───────────────────────────────────────── */
    function observeKaching() {
        patchBars();
        toggleFallback();

        const observer = new MutationObserver(() => {
            patchBars();
            toggleFallback();
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeKaching);
    } else {
        observeKaching();
        setTimeout(() => { patchBars(); toggleFallback(); }, 300);
        setTimeout(() => { patchBars(); toggleFallback(); }, 800);
        setTimeout(() => { patchBars(); toggleFallback(); }, 2000);
        setTimeout(() => { patchBars(); toggleFallback(); }, 4000);
    }
})();